import React, {Component} from 'react';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap'
import {Query} from 'react-apollo'
import { Link, withRouter } from "react-router-dom";
import moment from 'moment'

import query from '../../queries/server/notifications'
import subscription from '../../queries/server/subscriptions/notification_upserted'
import NotificationModal from './notifications/NotificationModal'

class Navigation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            user: JSON.parse(sessionStorage.getItem('user'))
        };
    }
    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    logout = () => {
        sessionStorage.clear()
        this.props.history.replace('/login')
    }

    render() {

        const {user: {user}} = this.state

        return (
            <div>
                <Query 
                    query={query} 
                    variables={{office_id: this.state.user.user.office_id}}
                    fetchPolicy="network-only"
                >
                    {({data, loading, subscribeToMore}) => {
                        
                        let newNotifications = []
                        let popupNotifications = []
                        if(!loading && data){
                            const userViewedNotificationsAt = moment(data.me.viewed_notifications_at)

                            newNotifications = data.notifications.filter(not => {
                                return moment(not.updated_at).isAfter(userViewedNotificationsAt)
                            })

                            popupNotifications = newNotifications.filter(not => not.popup)
                        }

                        return (
                            <div>
                            <Navbar color="light" light expand="md">
                                <NavbarBrand tag={Link} to="/dashboard">
                                    <img src="data:image/png;base64,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"/>
                                </NavbarBrand>
                                <NavbarToggler onClick={this.toggle} />
                                <Collapse isOpen={this.state.isOpen} navbar>
                                    <Nav className="mr-auto" navbar>
                                        <NavItem>
                                            <NavLink tag={Link} to="/dashboard">Dashboard</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink tag={Link} to="/timesheet">Timesheet</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink tag={Link} to="/expenses">Expenses</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink tag={Link} to="/staff_resource">Resource</NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink tag={Link} to="/projects">Projects</NavLink>
                                        </NavItem>
                                        <UncontrolledDropdown nav inNavbar>
                                            <DropdownToggle nav caret>
                                                Reports
                                            </DropdownToggle>
                                            <DropdownMenu left>
                                                <DropdownItem tag={Link} to="/reports/fee_drawdown">
                                                    Fee Drawdown
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/reports/hours_worked">
                                                    Office Hours Worked
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/reports/projects">
                                                    Projects
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/reports/project_invoicing">
                                                    Project Invoicing
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/reports/annual_leave">
                                                    Annual Leave
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                        <UncontrolledDropdown nav inNavbar>
                                            <DropdownToggle nav caret>
                                                Admin
                                            </DropdownToggle>
                                            <DropdownMenu left>
                                                <DropdownItem header>
                                                    Users
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/users">
                                                    Users
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/user_roles">
                                                    User Roles
                                                </DropdownItem>
                                                <DropdownItem divider/>
                                                <DropdownItem header>
                                                    Clients
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/clients">
                                                    Clients
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/client_types">
                                                    Client Types
                                                </DropdownItem>
                                                <DropdownItem divider/>
                                                <DropdownItem header>
                                                    Projects
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/project_activities">
                                                    Activities
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/project_disciplines">
                                                    Disciplines
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/project_statuses">
                                                    Statuses
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/project_fee_types">
                                                    Fee Types
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/project_land_uses">
                                                    Land Uses
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/project_contract_statuses">
                                                    Contract Statuses
                                                </DropdownItem>
                                                <DropdownItem divider/>
                                                <DropdownItem header>
                                                    Timesheets
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/unbillable_types">
                                                    Unbillable Types
                                                </DropdownItem>
                                                <DropdownItem divider/>
                                                <DropdownItem header>
                                                    Misc
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/address_types">
                                                    Address Types
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/contact_mediums">
                                                    Contact Mediums
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/project_expense_types">
                                                    Project Expense Types
                                                </DropdownItem>
                                                <DropdownItem tag={Link} to="/system_settings">
                                                    System Settings
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>


                                    </Nav>
                                    <Nav className="ml-auto" navbar>
                                        <NavItem>
                                            {!loading && data &&
                                                <NavLink tag={Link} to="/notifications">
                                                    Notifications <Badge color="danger">{newNotifications.length}</Badge>
                                                </NavLink>
                                            }   
                                        </NavItem>
                                        <UncontrolledDropdown nav inNavbar>
                                            <DropdownToggle nav caret>
                                                {user.first_name} {user.last_name}
                                            </DropdownToggle>
                                            <DropdownMenu right>
                                                <DropdownItem tag={Link} to="/annual_leave">
                                                    Annual Leave
                                                </DropdownItem>
                                                <DropdownItem divider/>
                                                <DropdownItem onClick={this.logout}>
                                                    Log out
                                                </DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </Nav>
                                </Collapse>
                            </Navbar>
                            <NotificationModal 
                                isOpen={popupNotifications.length} 
                                data={newNotifications}
                                office_id={this.state.user.user.office_id}
                                subscribeToUpsert={() => {
                                    subscribeToMore({
                                        document: subscription,
                                        variables: {
                                            office_id: this.state.user.user.office_id
                                        },
                                        updateQuery: (prev, {subscriptionData: {data}}) => {
                                            if(!data) return prev

                                            console.log('prev', prev)

                                            const index = prev.notifications.findIndex(({id}) => data.notificationUpserted.id === id)

                                            if(index !== -1){

                                                if(!data.notificationUpserted.active){
                                                    console.log('delete', data, prev)
                                                    return {
                                                        ...prev,
                                                        notifications: [
                                                            ...prev.notifications.filter(({id}) => id !== data.notificationUpserted.id)
                                                        ]
                                                    }
                                                }

                                                console.log('update', data, prev, {
                                                    ...prev,
                                                    notifications: [
                                                        ...prev.notifications.slice(0, index),
                                                        data.notificationUpserted, 
                                                        ...prev.notifications.slice(index + 1)
                                                    ]
                                                })

                                                return {
                                                    ...prev,
                                                    notifications: [
                                                        ...prev.notifications.slice(0, index),
                                                        data.notificationUpserted, 
                                                        ...prev.notifications.slice(index + 1)
                                                    ]
                                                }
                                            }

                                            console.log('new', data, prev, {
                                                ...prev,
                                                notifications: [data.notificationUpserted, ...prev.notifications]
                                            })

                                            return {
                                                ...prev,
                                                notifications: [data.notificationUpserted, ...prev.notifications]
                                            }
                                        }
                                    })
                                }}
                            />
                            </div>)
                    }}
                </Query>
                
            </div>
        );
    }
}

export default withRouter(Navigation)